<template>
  <div class="cloudflare-media-view">
    <CloudflareMediaDemo />
  </div>
</template>

<script>
import CloudflareMediaDemo from '@/components/CloudflareMediaDemo.vue';

export default {
  name: 'CloudflareMediaView',
  components: {
    CloudflareMediaDemo
  }
}
</script>

<style>
.cloudflare-media-view {
  padding: 20px;
}
</style> 